export { usePaginationBehavior, default as Pagination } from './src/Pagination'
